<template>
	<div class="job-fuzzy-matrix--value-group">
		<div v-if="category.label" class="job-fuzzy-matrix--value-group-label">{{ category.label }}</div>
		<ul class="job-fuzzy-matrix--values">
			<Value
				v-for="value in values"
				:key="value.id"
				:row="row"
				:value="value"
				@filter="$emit('filterValue', $event)"
			/>
		</ul>
	</div>
</template>

<script>
import Value from "./Value";

export default {

	components: {
		Value,
	},

	props: {
		category: {
			type: Object,
			required: true,
		},
		row: {
			type: Object,
			required: true,
		},
		values: {
			type: Array,
			required: true,
		},
	},
}
</script>
